import styled from "styled-components";
import { Fold, Lens } from "@discovery/prelude/lib/control/lens";
import * as M from "@discovery/prelude/lib/data/maybe";
import { mkSiteBuilderComponent } from "@discovery/template-engine/lib/component-map";
import { optional, record, string, } from "@discovery/prelude/lib/data/validated";
import { _GetCustomAttributesForComponent } from "@discovery/sonic-api-ng-optics";
import * as Optics from "@discovery/sonic-api-ng-optics";
import { RenderMaybe } from "@discovery/components-luna-react/lib/utils/render-maybe";
import { DesktopView } from "./desktopView";
import { MobileView } from "./mobileView";
import { useWindowSize } from "../../utils/hooks";
import { GroupTitle, Container78VW, AlignCenter } from "../../styles/common";
import { media } from "../../styles/breakpoints";
import { neutral3, brandmedium } from "../../css/colors";
const GradientContainer = styled.div `
  background: radial-gradient(38% 20% at top, ${neutral3}, ${brandmedium});
`;
const CardContainer = styled.div `
  padding: 64px 0px;
  @media ${media.medium.down} {
    padding: 45px 60px;
  }
  @media ${media.xsmall.down} {
    padding: 0px 16px 50px 16px;
  }
`;
const Container = styled(Container78VW) `
  @media ${media.medium.down} {
    max-width: 100vw;
  }
`;
const getProps = (data) => {
    const customAttrValidator = optional(record({
        rating: string,
    }));
    const _UserReviews = Fold.compose(Optics._CollectionGetter, Optics._Col2Items, Optics._ColItem2Collection, Fold.liftM((description, rating, author) => ({
        description,
        rating,
        author,
    }), Optics._ColAttributes2Description, Fold.compose(Fold.pre(_GetCustomAttributesForComponent(customAttrValidator)), M._Just(), M._Just(), Lens.prop("rating")), Optics._ColAttributes2Title));
    const userReviews = Fold.toArray(_UserReviews, data);
    const titleM = Fold.view(Optics._ColAttributes2Title, data);
    return { userReviews, titleM };
};
const UserReview = ({ userReviews, titleM }) => {
    const [width] = useWindowSize();
    return (React.createElement(Container, null,
        React.createElement(GradientContainer, null,
            React.createElement(AlignCenter, null,
                React.createElement(RenderMaybe, null, M.map((title) => (React.createElement(GroupTitle, null, title)), titleM))),
            React.createElement(CardContainer, null, width <= 1024 ? (React.createElement(MobileView, { userReviews: userReviews, autoplay: 5000, loop: userReviews.length > 1, width: width })) : (React.createElement(DesktopView, { userReviews: userReviews }))))));
};
export const ComponentMapItem = mkSiteBuilderComponent(getProps, UserReview);

